export default function classes(...classNames: any[]) {
  return classNames.filter(Boolean).join(' ');
}